<template>
  <div class="searchbox-wrapper">
    <input
      type="text"
      class="form-control"
      ref="search-box"
      :value="searchQuery"
      @input="updateSearchQuery($event)"
      :placeholder="placeholder"
      :class="{ 'with-icon': isWithIcon }"
      @keyup.enter="handleSearch"
      @blur="handleBlur"
    />
    <div class="icon-wrapper clear" v-show="searchQuery" @click="clearQuery">
      <fa icon="times-circle"></fa>
    </div>
    <div
      v-if="isWithIcon"
      v-show="!searchQuery"
      class="icon-wrapper search"
      @click="handleSearch"
    >
      <fa icon="search" class="icon"></fa>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
export default {
  name: 'SearchBox',
  props: {
    isWithIcon: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Input search keyword'
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
    ...mapState('alertsSuspiciousTrafficStore', ['searchQuery']),
    ...mapGetters('alertsSuspiciousTrafficStore', [
      'alertNameListOfSelectedMemberId'
    ])
  },
  methods: {
    ...mapMutations('alertsSuspiciousTrafficStore', [
      'setAlertNameQuery',
      'setSearchQuery'
    ]),
    handleSearch() {
      this.setAlertNameQuery(this.searchQuery);
    },
    handleBlur() {
      this.setAlertNameQuery(this.searchQuery);

      if (!this.searchQuery && this.isMobile) {
        // Hide search box if it is on mobile devices and there is no input when losing focus
        this.$emit('onCloseSearchBox');
      }
    },
    clearQuery() {
      this.setSearchQuery('');
    },
    updateSearchQuery(event) {
      this.setSearchQuery(event.target.value.trim());
    }
  },
  watch: {
    searchQuery(val, prevVal) {
      // Debounce handleSearch
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.handleSearch();
      }, 300);
    },
    alertNameListOfSelectedMemberId: {
      // immediate: true,
      handler() {
        this.setSearchQuery('');
        this.setAlertNameQuery('');
      }
    }
  },
  mounted() {
    this.setSearchQuery('');
    this.isMobile && this.$refs['search-box'].focus();
  }
};
</script>

<style lang="scss" scoped>
.searchbox-wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 15rem;

  .with-icon {
    padding-right: 2rem;
  }

  .icon-wrapper {
    position: absolute;
    right: 0;
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    cursor: pointer;
    color: $text-grey;

    &:hover {
      color: $icon-grey;
    }
  }
}
</style>
